[
	{
		"title":"Main",
		"more": ": @shadowlerone",
		"href": "https://short.shadowlerone.ca/igmain",
		"icon-class":"bi-instagram"
	},
	{
		"title":"Photography",
		"more": ": @enorelwodahs",
		"href": "https://short.shadowlerone.ca/igphoto",
		"icon-class":"bi-instagram"
	},
	{
		"title":"Aviation",
		"more":": @shadowlerone.cyul",
		"href": "https://short.shadowlerone.ca/igavia",
		"icon-class":"bi-instagram"
	},
	{
		"title":"Linkedin",
		"more":"",
		"href": "https://short.shadowlerone.ca/linkedin",
		"icon-class":"bi-linkedin"
	},
	{
		"title":"YouTube",
		"more":"",
		"href": "https://short.shadowlerone.ca/yt",
		"icon-class":"bi-youtube"
	},
	{
		"title":"Spotify",
		"more":"",
		"href": "https://short.shadowlerone.ca/spotify",
		"icon-class":"bi-spotify"
	},
	{
		"title":"Github",
		"more":"",
		"href": "https://short.shadowlerone.ca/github",
		"icon-class":"bi-github"
	}
]